import { setContext } from '@apollo/client/link/context';
import { COOKIE_FIREBASE_SESSION } from '@application/constants';
import { cookies } from '@application/utils';

export const authLink = (initialToken?: string) =>
  setContext(async (req, { headers }) => {
    let token = initialToken;

    if (typeof window !== 'undefined') {
      // Cookie can change on the client
      token = cookies.get<string>(COOKIE_FIREBASE_SESSION) ?? undefined;
    }

    return {
      headers: {
        ...headers,
        ...(token ? { authorization: token } : {}),
      },
    };
  });
